import { classNames } from "primereact/utils";
import { MessageStatus } from "../emailLogs/models/emailLogModel";
import styles from "./StatusChip.module.scss";

const STATUS_CONFIG: Record<MessageStatus, { label: string; className: string }> = {
  [MessageStatus.Pending]: { label: "Чакащ", className: styles.chip_pending },
  [MessageStatus.Sent]: { label: "Изпратен", className: styles.chip_sent },
  [MessageStatus.Failed]: { label: "Неуспешен", className: styles.chip_failed },
  [MessageStatus.Cancelled]: { label: "Отменен", className: styles.chip_cancelled },
};

/** The status of an email, SMS or device notification in the communication logs. */
export const StatusChip = ({ status }: { status: MessageStatus }) => {
  const { label, className } = STATUS_CONFIG[status];
  return <span className={classNames(styles.chip, className)}>{label}</span>;
};
